import * as $ from "jquery";

export default class FooterBar {
	el: HTMLElement;
	form:  HTMLFormElement;
	closeButton: HTMLButtonElement;

	barHeight: number = 0;

	filler: HTMLElement;
	fillerTop: number = 0;

	checkTop: number = 0;

	constructor() {
		const bar = <HTMLElement> document.getElementById("footer-location-finder");
		if (bar) {
			this.el = bar;

			const form = <HTMLFormElement> this.el.querySelector("form");
			this.form = form;

			const closeButton = <HTMLButtonElement> this.el.querySelector("button.close-finder");
			this.closeButton = closeButton;

			this.barHeight = this.el.offsetHeight;

			this.createFiller();
			this.watch();
		}
	}

	watch() {
		this.form.addEventListener("submit", (e) => {
			console.log("submit footer finder search...");
		});

		this.closeButton.addEventListener("click", (e) => {
			e.preventDefault();
			this.closeBar();
		});
	}

	checkSticky() {
		this.checkTop = $(document).scrollTop() + ($(window).innerHeight() - $(this.el).innerHeight());

		if (this.filler && this.checkTop > $(this.filler).offset().top) {
			this.filler.setAttribute("data-active", "true");
			this.el.setAttribute("data-locked", "true");
		} else {
			if (this.filler) {
				this.filler.setAttribute("data-active", "false");
			}
			this.el.removeAttribute("data-locked");
		}
	}

	createFiller() {
		if (this.el.getAttribute("data-status") === "sticky") {
			const pageFooter = document.querySelector("body > footer");
			if (pageFooter) {
				const filler = document.createElement("div");
				filler.classList.add("footer-finder-filler");

				this.filler = <HTMLElement> document.body.insertBefore(filler, pageFooter);
				this.filler.style.height = this.el.offsetHeight + "px";
			}
		}
	}

	closeBar() {
		this.el.setAttribute("data-locked", "true");
		this.el.setAttribute("data-status", "locked");
		this.filler.style.height = "0px";
	}
}